<template>
	<i :class="classes" :style="style"></i>
</template>

<script>

	export default {
		name: 'BIcon',
		props: {
			icon:      { type: String, default: '' },
			fontScale: { type: [String, Number], default: null },
			variant:   { type: String, default: null },
			rotate:    { type: [String, Number], default: null },
			flipH:     { type: Boolean, default: false },
			flipV:     { type: Boolean, default: false }
		},
		computed: {
			classes() {
				const c = ['bi', `bi-${this.icon}`];
				if (this.variant) c.push(`text-${this.variant}`);
				return c;
			},
			style() {
				const s = {};
				if (this.fontScale != null) s.fontSize = `${this.fontScale}em`;
				const t = [];
				if (this.rotate != null) t.push(`rotate(${this.rotate}deg)`);
				if (this.flipH) t.push('scaleX(-1)');
				if (this.flipV) t.push('scaleY(-1)');
				if (t.length) s.transform = t.join(' ');
				return s;
			}
		}
	}
</script>
